var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Box',_vm._b({staticClass:"form-section",attrs:{"marginBottom":6}},'Box',_vm.$attrs,false),[(_vm.hasHeaderSlot)?_c('Box',{attrs:{"tag":"header","marginBottom":4}},[_vm._t("header"),(_vm.hasNoteSlot)?_c('layoutText',{staticClass:"note",attrs:{"fontSize":1}},[_vm._t("note")],2):_vm._e()],2):_vm._e(),_vm._t("main")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }